export default __webpack_public_path__ + "static/media/atados-logo.39856fc0.png";